import { CustomerDetailsAction } from "./actions";
import * as actionTypes from "./actionTypes";
import { CustomerDetailsModel } from "./models";

export function reducer(state: CustomerDetailsModel = null, action: CustomerDetailsAction) {
    switch (action.type) {
        case actionTypes.LOAD_CUSTOMER_DETAILS_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}
